
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"20 9 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M43.914 24.191c-.2-2.016-1.943-2.687-4.142-2.872l-.009-2.798-1.703.006.009 2.724c-.448.001-.905.011-1.36.022l-.008-2.742-1.702.005.008 2.797c-.369.009-.73.017-1.084.018v-.008l-2.349.006.006 1.819s1.258-.028 1.237-.005c.69-.002.916.398.982.743l.024 7.665c-.03.217-.156.564-.638.566.022.019-1.238.004-1.238.004l-.331 2.034 2.216-.007c.412 0 .818.005 1.216.006v2.83h1.702v-2.805c.467.008.92.01 1.36.009l.009 2.796h1.662l.032-2.84c2.863-.173 4.864-.9 5.105-3.59.194-2.166-.828-3.128-2.454-3.514.986-.505 1.6-1.393 1.45-2.869zm-2.363 6.058c.008 2.115-3.614 1.886-4.768 1.89l-.011-3.749c1.154-.003 4.772-.346 4.779 1.86zm-.809-5.287c.006 1.924-3.014 1.71-3.976 1.712l-.01-3.4c.96-.003 3.98-.318 3.986 1.688z","fill":"#F7931A"}})])
          )
        }
      }
    